import { localStorageUtils } from "../helpers/storageHelper";
import api from "./axiosConfig"

export const refreshAccessToken = async () => {
    return api.post('/user/auth/refresh', {
        refreshToken: localStorageUtils.getLocalStorageItem('refreshToken')
    })
    .then(res => {
        if (res.status === 200) {
            const token = res.data.data.accessToken;
            localStorageUtils.setLocalStorageItem('token', token);
            return token;
        }
    })
    .catch(error => Promise.reject(error))
}